module.exports = __webpack_public_path__ + "static/media/confirmation.56f156a2.jpg";